<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.search_competency_indicator_fildes"
      :url="competency_indicator_url"
      :visibleAdd="false"
      :remove_item="remove_item"
      :toggleable="true"
      removeModalSize="xl"
      addModalSize="lg"
      :dynamicButtons="buttonscompetencyIndicator"
      :defaultViewCount="50"
      ref="competency_indicator_search"
      :order_by="`value:desc`"
      :extraButtons="extraButtons"
    >
      <template slot="title-bar">
        {{ $lang.competency_indicator_list }}: <b>{{ nameCompetency }}</b>
        <div v-if="competency_refrence">
          <br />
          {{ this.$lang.competency_reference }} :
          <b> {{ competency_refrence }}</b>
        </div>
      </template>
    </Search>

    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="modalAddIndicator"
      size="xl"
      hide-footer
      hide-header
    >
      <SelectSearch
        v-if="mode == 'listIndicator'"
        ref="listIndicator"
        :title="$lang.indicator"
        :url="indicator_url"
        v-model="Indicators"
        :allowFields="$lang.competency_select_indicator"
        :limitOneSelect="false"
        :query="`is_enable=1`"
        :visibleSearch="true"
      >
        <template slot="buttons">
          <b-button
            class="btn-lightgray ml-1"
            @click="indicatorModal = true"
            v-b-tooltip.hover
            :title="$lang.add_indicator"
          >
            <i class="fa fa-plus"></i>
          </b-button>
        </template>
      </SelectSearch>

      <div class="form-group float-right mt-2" v-if="mode == 'listIndicator'">
        <b-button
          variant="success"
          class="ml-1"
          @click="
            putIndicator();
            modalAddIndicator = false;
          "
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>

        <b-button
          variant="danger"
          class="ml-1"
          @click="modalAddIndicator = false"
        >
          {{ $lang.cancelButton }}
          <i class="fa fa-ban"></i>
        </b-button>
      </div>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="indicatorModal"
      size="xl"
      hide-footer
      hide-header
    >
      <AddIndicator
        :isModal="true"
        @modal-end-up="closeIndicatorModal"
        ref="addIndicator"
        @getItems="getItems"
      />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddIndicator from "./../indicator/addIndicator";
import SelectSearch from "@/components/base/selectSearch";
import { pathOr } from "ramda";
import { goToRoute } from "@/shared/utils";
export default {
  name: "competencyIndicator",
  inject: ["competencyRepository"],
  components: {
    Search,
    AddIndicator,
    SelectSearch,
  },
  data() {
    return {
      id: this.$route.params.id,
      mode: "",
      modalAddIndicator: false,
      Indicators: [],
      competency_refrence: null,
      isLoading: false,
      indicator_url: this.$config.api_url + this.$config.kanoon.indicator,
      competency_indicator_url:
        this.$config.api_url +
        this.$config.kanoon.competency_indicator.replace(
          "{0}",
          this.$route.params.id
        ),
      nameCompetency: null,
      buttonscompetencyIndicator: [
        {
          id: "0",
          name: "view",
        },
        {
          id: "1",
          name: "delete",
        },
        {
          id: "2",
          name: "design",
          click: this.indicatorEvidence,
        },
      ],
      indicatorModal: false,
    };
  },
  computed: {
    title_Competency() {
      return `${this.$lang.competency_indicator_list.replace(
        `{0}`,
        this.nameCompetency
      )}
        ${this.$lang.competency_reference} : ${this.competency_refrence} `;
    },
    extraButtons() {
      return [
        {
          name: "showListIndicator",
          condition: true,
          title: this.$lang.choose_indicator,
          click: this.showListIndicator,
          iconName: "format-list-bulleted-type",
        },
      ];
    },
  },
  methods: {
    pathOr,
    goToRoute,
    indicatorEvidence(item) {
      const id = pathOr(null, ["id"], item);
      if (!id) return;
      goToRoute("indicator-evidence", { id }, {}, false);
    },
    async fetchData() {
      try {
        const response = await this.competencyRepository.find(
          this.$route.params.id
        );
        let data = response.data.data;
        this.nameCompetency = data.name;
        this.competency_refrence = data.reference && data.reference.caption;
      } catch (error) {
        this.$generateError(error);
      }
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.competency_indicator_url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((error) => {
          this.$generateError(error);
          throw "error";
        })
        .finally(() => {
          this.$refs.competency_indicator_search.getItems();
        });
    },
    getItems() {
      this.$refs.competency_indicator_search.getItems();
    },
    showListIndicator() {
      this.mode = "listIndicator";
      this.Indicators = this.$refs.competency_indicator_search.items.map(
        (x) => {
          if (x.id)
            return {
              id: x.id,
            };
        }
      );

      this.modalAddIndicator = true;
    },
    addIndicator() {
      this.modalAddIndicator = true;
    },
    putIndicator() {
      let payload = {
        indicator_id: this.Indicators.map((c) => c.id),
      };

      return this.$httpService
        .put(this.competency_indicator_url, payload)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify(err);
        })
        .finally(() => {
          this.$refs.competency_indicator_search.getItems();
        });
    },
    closeIndicator() {
      this.modalAddIndicator = false;
    },
    closeIndicatorModal() {
      this.indicatorModal = false;
      this.$refs.listIndicator.getItems();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style></style>
